<script setup lang="ts">
import { computed } from 'vue';
import { RenderDate, RenderPhone, RenderEmail, RenderAddress, ReviewSection, LoadingText } from '@hfc/ui-core';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessState } = useSmallBusinessStore();

const dataLoaded = computed(() => !!smallBusinessState.value.application.company.main_address.zip_code);

</script>
<template>
  <ReviewSection section-title="" :editable="false" :section-number="1">
    <template #content>
      <div>
        <div class="flex flex-col lg:flex-row lg:space-x-8 mt-4">
          <div class="lg:w-80 mb-4">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Number of Employees
            </label>
            <div class="flex items-center text-xl space-x-4 lining-nums">
              <hfc-icon class="h-5 text-blue-500" :icon="smallBusinessState.application.applicants.length > 2 ? 'people-group' : 'user-group'" />
              <span v-if="dataLoaded" class="mt-0.5">{{ smallBusinessState.application.applicants.length }}</span>
              <LoadingText v-else class="mt-0.5" width="w-6" height="h-5" />
            </div>
          </div>
          <div>
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Zip Code
            </label>
            <div class="flex items-center text-lg space-x-4 lining-nums">
              <RenderAddress v-if="dataLoaded" :county="smallBusinessState.application.company.main_address.county" :zip="smallBusinessState.application.company.main_address.zip_code" />
              <LoadingText v-else icon="location-dot" class="mt-0.5" width="w-40" height="h-5" />
            </div>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:space-x-8 mt-4 lg:mt-0">
          <div class="lg:w-80 mb-4">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Email Address
            </label>
            <div class="flex items-center text-lg space-x-4 lining-nums">
              <RenderEmail v-if="dataLoaded" :email="smallBusinessState.application.company.primary_contact?.email" />
              <LoadingText v-else icon="envelope" class="mt-0.5" width="w-40" height="h-5" />
            </div>
          </div>
          <div>
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Phone
            </label>
            <div class="flex items-center text-lg space-x-4 lining-nums">
              <RenderPhone v-if="dataLoaded" :phone="smallBusinessState.application.company.primary_contact?.phone?.toString()" />
              <LoadingText v-else icon="phone" class="mt-0.5" width="w-40" height="h-5" />
            </div>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row mt-4">
          <div class="flex flex-col lining-nums">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              <span class="font-medium mb-1 whitespace-nowrap text-sky-700">Desired effective date:</span>
            </label>
            <div class="flex items-center text-lg space-x-4 lining-nums">
              <RenderDate v-if="dataLoaded" :date="smallBusinessState.application.effective_date" />
              <LoadingText v-else icon="calendar-day" class="mt-0.5" width="w-40" height="h-5" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </ReviewSection>
</template>
